import { Button, Col, Row, Select } from "antd";
import React, { Component } from "react";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import { connect } from "react-redux";
import Card from "../../../components/Card";
import MainLayout from "../../../components/Layout/MainLayout";
import { getDataQuan } from "../../../redux/actions/search.action";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import StaticClass from "../../../utils/staticClass";
import ChartPrint from "../../Statistic/TablePrint";
import "../thong-ke.scss";
class ThongKe10000 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMatBang: undefined,
      selectedLoaiDat: undefined,

      listMatBang: [],
      listLoaiDat: [],

      dataTable: [],
    };
  }

  componentDidMount() {
    if (this.props.listQuan.length === 0) this.props.getDataQuan();
    this.getDataLoaiDat();
    this.getDataMatBang();
    this.onSearchClick();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
    }
  }

  async getDataLoaiDat() {
    let res = await AxiosGetSecretApi("/api/bang-mau/all");
    if (res && Array.isArray(res)) {
      this.setState({
        listLoaiDat: res,
      });
    }
  }

  async getDataMatBang() {
    let res = await AxiosGetSecretApi("/api/qh-chung/cbMatBang");
    if (res && Array.isArray(res)) {
      this.setState({
        listMatBang: res,
      });
    }
  }

  onChangeMatBang(value) {
    this.setState({
      selectedMatBang: value,
    });
  }

  resetButton = () => {
    this.setState({
      selectedMatBang: undefined,
      selectedLoaiDat: undefined,
    });
    this.onSearchClick("TimMoi");
  };

  async onSearchClick(e) {
    let url = "/api/thongke/qh-chung-by-huyen?";
    if (this.state.selectedMatBang) {
      let matBang = encodeURIComponent(this.state.selectedMatBang);
      url += `LoaiQH=${matBang}&`;
    }
    if (this.state.selectedLoaiDat) {
      let loaiDat = encodeURIComponent(this.state.selectedLoaiDat);
      url += `LoaiDat=${loaiDat}&`;
    }

    if (e === "TimMoi") {
      url = "/api/thongke/qh-chung-by-huyen?";
    }
    let res = await AxiosGetSecretApi(url);

    if (res && Array.isArray(res)) {
      this.setState({
        dataTable: res,
      });
    } else {
      this.setState({
        dataTable: [],
      });
    }
  }

  render() {
    const dataTable = this.state.dataTable.map((o, i) => {
      return (
        <tr key={i}>
          <td>{i + 1}</td>
          {/* <td style={{ textAlign: "left", paddingLeft: "10px" }}>
            {o.MatBang}
          </td> */}
          <td style={{ textAlign: "left", paddingLeft: "10px" }}>
            {o.LoaiDat}
          </td>
          <td style={{ textAlign: "right", paddingRight: "10px" }}>
            {StaticClass.formatPrice(o.DienTich)}
          </td>
          <td style={{ textAlign: "right", paddingRight: "10px" }}>{StaticClass.formatPrice(o.TyLe)}</td>
        </tr>
      );
    });

    return (
      <MainLayout
        title={"Thống kê chi tiết dự án quy hoạch chung 1/10000"}
        {...this.props}
      >
        <div className="page-with-card">
          <Card title="Thống kê chi tiết dự án quy hoạch chung 1/10000">
            <div className="thong-ke thong-ke-10000">
              <div className="fl-center">
                <div style={{ width: "900px" }}>
                  <Row gutter={[20, 0]}>
                    <Col span={6} className="group">
                      <div className="gr-title">
                        <div className="text">Mặt bằng</div>
                      </div>

                      <div className="gr-body">
                        <Select
                          className="select"
                          showSearch
                          value={this.state.selectedMatBang}
                          onChange={(value) => this.onChangeMatBang(value)}
                        >
                          {this.state.listMatBang.map((e, i) => (
                            <Select.Option value={e.LoaiQH} key={i}>
                              {e.LoaiQH}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </Col>

                    <Col span={6} className="group">
                      <div className="gr-title">
                        <div className="text">Loại đất:</div>
                      </div>

                      <div className="gr-body">
                        <Select
                          className="select"
                          showSearch
                          value={this.state.selectedLoaiDat}
                          onChange={(value) => {
                            this.setState({ selectedLoaiDat: value });
                          }}
                        >
                          {this.state.listLoaiDat.map((e, i) => (
                            <Select.Option key={i} value={e.TenloaiPolygon}>
                              {e.TenloaiPolygon}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                  </Row>

                  <div
                    style={{
                      display: "flex",
                      marginTop: "15px",
                      marginBottom: "10px",
                    }}
                  >
                    <Button
                      type="primary"
                      className="button"
                      style={{
                        width: "117px",
                        fontWeight: 700,
                        height: "40px",
                      }}
                      onClick={this.resetButton}
                    >
                      Tìm mới
                    </Button>
                    <Button
                      type="primary"
                      className="button"
                      style={{
                        width: "117px",
                        marginLeft: "10px",
                        fontWeight: 700,
                        height: "40px",
                      }}
                      onClick={() => {
                        this.onSearchClick();
                      }}
                    >
                      Tìm kiếm
                    </Button>
                  </div>

                  <div>
                    <table id="chart-table" style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <th style={{ width: "10%" }}>STT</th>
                          {/* <th style={{ width: "20%" }}>Mặt bằng</th> */}
                          <th style={{ width: "40%" }}>Loại đất</th>
                          <th style={{ width: "15%" }}>Diện tích (ha)</th>
                          <th style={{ width: "15%" }}>Tỷ lệ (%)</th>
                          {/* <th>Mặt bằng</th> */}
                        </tr>
                        {dataTable}
                      </tbody>
                    </table>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      marginTop: "15px",
                      marginBottom: "10px",
                      justifyContent: "center",
                    }}
                  >
                    <ReactHtmlTableToExcel
                      id="test-table-xls-button"
                      className="ant-btn ant-btn-primary-cus"
                      table="chart-table"
                      filename={
                        "Thống kê chi tiết dự án quy hoạch chung 1/10000"
                      }
                      sheet="tablexls"
                      buttonText="Tải Excel"
                    />
                    <Button
                      type="primary"
                      className="button"
                      style={{
                        width: "117px",
                        marginLeft: "10px",
                        fontWeight: 700,
                        height: "40px",
                      }}
                      onClick={() =>
                        ChartPrint(
                          "Thống kê chi tiết dự án quy hoạch chung 1/10000"
                        )
                      }
                    >
                      In
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    listQuan: state.search.listQuan,
  };
};

const mapDispatchToProps = {
  getDataQuan: getDataQuan,
};

export default connect(mapStateToProps, mapDispatchToProps)(ThongKe10000);
